import React, { useState } from 'react';
import { Button, TextField, Typography, Box } from '@mui/material';
import { verifyCustomerResetToken } from '../../helpers/httpRequests/passwordReset';

export default function VerifyTokenStep({ email, token, setToken, onSuccess, onBack }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await verifyCustomerResetToken(email, token);
      if (res?.error) {
        setError(res.message || 'Código inválido ou expirado.');
      } else {
        onSuccess();
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography mb={2}>Digite o código enviado para o seu e-mail:</Typography>
      <TextField
        label="Código"
        value={token}
        onChange={e => setToken(e.target.value)}
        fullWidth
        required
        margin="normal"
      />
      {error && <Typography color="error" mt={1}>{error}</Typography>}
      <Box display="flex" gap={2} mt={2}>
        <Button onClick={onBack} variant="outlined" color="primary" fullWidth>
          Voltar
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          fullWidth
          disabled={loading || !token}
        >
          {loading ? 'Verificando...' : 'Verificar'}
        </Button>
      </Box>
    </form>
  );
}
